import { connect } from 'react-redux'
import { selectPreSaleFlag, selectCurrentPhone } from '../App/selectors'
import { selectLandingCategories } from '../FAQs/selectors'
import { SupportLanding } from '../../components'
import { createEvent } from '../UserEvents/actions'

const mapStateToProps = (state, ownProps) => ({
  preSaleFlag: selectPreSaleFlag(state),
  currentPhone: selectCurrentPhone(state),
  location: ownProps.location,
  query: state.routing.locationBeforeTransitions.query,
  isLandingPage: ownProps.isLandingPage,
  landingCategories: selectLandingCategories(state)
})

const mapDispatchToProps = dispatch => ({
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupportLanding)



// WEBPACK FOOTER //
// ./src/containers/SupportLanding/SupportLanding.js